import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  List,
  ListItem,
  Button,
  Checkbox,
  FormControlLabel,
  Paper,
  Container
} from "@mui/material";

const TermsAndConditions = ({ open, onClose, onAccept }) => {
  const [accepted, setAccepted] = useState(false);

  if (!open) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          maxHeight: '90vh',
          overflow: 'hidden',


        }
      }}
    >
      <DialogContent sx={{ p: 0, bgcolor: '#f9f9f9' }}>
        {/* <Container maxWidth="md" sx={{ py: 4, backgroundColor: "red" }}> */}
        <Paper elevation={3} sx={{ p: { xs: 3, sm: 6 }, borderRadius: 3 }}>
          <Typography
            variant="h4"
            align="center"
            sx={{ fontWeight: "bold", mb: 1, color: "#000" }}
          >
            TERMS AND CONDITIONS
          </Typography>

          <Typography
            variant="h6"
            align="center"
            sx={{ fontWeight: "bold", color: "#000", mb: 3 }}
          >
            echoBuddy Daily Yoga
          </Typography>

          <Box
            sx={{
              backgroundColor: "#f0f0f0",
              borderLeft: "4px solid #333",
              p: 2,
              fontSize: "0.9rem",
              mb: 3,
            }}
          >
            BY PARTICIPATING IN THIS SESSION, YOU ACKNOWLEDGE THAT YOU HAVE
            READ, UNDERSTOOD, AND AGREE TO BE BOUND BY THE FOLLOWING TERMS AND
            CONDITIONS:
          </Box>

          <List sx={{ listStyleType: "decimal", pl: 4 }}>
            {[
              {
                title: "Nature of Session:",
                text: "This session is intended for general wellness and relaxation purposes only and does not constitute medical advice, diagnosis, or treatment.",
              },
              {
                title: "Safety Requirements:",
                text: "Participants must practice in a safe, clear, and non-slip space with water readily available nearby.",
              },
              {
                title: "Medical Clearance:",
                text: "If you have any medical condition or injury, consult a doctor before participating.",
              },
              {
                title: "Listen to Your Body:",
                text: "Stop immediately if you feel any pain, dizziness, or discomfort.",
              },
              {
                title: "Practice Guidelines:",
                text: "Practice every day on an empty stomach if possible, adjusting for your needs.",
              },
              {
                title: "No Requirement for Perfection:",
                text: "You don't need perfect poses — move mindfully and safely.",
              },
              {
                title: "Voluntary Participation:",
                text: "Participation is entirely voluntary. Modify or skip any step as needed.",
              },
              {
                title: "Assumption of Risk and Personal Responsibility:",
                text: "You are responsible for your own safety and understand the inherent physical risks.",
              },
              {
                title: "Release of Liability:",
                text: "You release the session provider from any injury, damage, or loss arising from participation.",
              }
            ].map((item, index) => (
              <ListItem
                key={index}
                sx={{ display: "list-item", color: "#333", mb: 1.5 }}
              >
                <Typography variant="body2">
                  <strong style={{ color: "#000" }}>{item.title}</strong>{" "}
                  {item.text}
                </Typography>
              </ListItem>
            ))}
          </List>

          <Box
            sx={{
              backgroundColor: "#f8f8f8",
              p: 2,
              borderRadius: 2,
              fontStyle: "italic",
              fontSize: "0.9rem",
              mt: 3,
            }}
          >
            By participating in this session, you confirm that you have read and
            fully understand these Terms and Conditions.
          </Box>

          <Box
            sx={{
              backgroundColor: "#f0f7ff",
              border: "2px solid #4CAF50",
              borderRadius: 2,
              mt: 4,
              p: 3,
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={accepted}
                  onChange={(e) => setAccepted(e.target.checked)}
                  color="success"
                />
              }
              label={
                <Typography sx={{ fontWeight: "bold", fontSize: "0.9rem" }}>
                  I have read and accept the Terms and Conditions
                </Typography>
              }
            />

            <Button
              variant="contained"
              color="success"
              fullWidth
              disabled={!accepted}
              onClick={() => {
                onAccept();
                onClose();
              }}
              sx={{
                mt: 2,
                fontWeight: "bold",
                py: 1.2,
                textTransform: "none",
              }}
            >
              Accept and Continue
            </Button>
          </Box>
        </Paper>
        {/* </Container> */}
      </DialogContent>
    </Dialog>
  );
};

export default TermsAndConditions;